"use client";
import { useTranslations } from "next-intl";
import { Link } from "@/navigation";
import { cn } from "@/lib/utils";

// 箭头图标
const ArrowIcon = () => (
    <svg
        className="h-4 w-4 transition-transform group-hover:translate-x-1"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
    >
        <path d="M5 10h10M12 6l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// 组件 Props 接口
export interface SmallCtaProps {
    translationNamespace?: string;
    customText?: string;
    customButtonText?: string;
    buttonHref?: string;
    className?: string;
}

export default function SmallCta({
    translationNamespace = "fiveAxisIntroCompare",
    customText,
    customButtonText,
    buttonHref = "/upload",
    className,
}: SmallCtaProps) {
    const t = useTranslations(translationNamespace);

    return (
        <div className={cn("container py-8 sm:py-10 md:py-12 lg:py-16", className)}>
            {/* 行动号召区域 */}
            <div className="flex flex-col items-center justify-between gap-6 sm:flex-row sm:gap-4">
                <p className="text-sm leading-relaxed text-black md:text-base">
                    {customText || t("ctaText")}
                </p>
                <Link
                    href={buttonHref}
                    className="group hover:text-white inline-flex items-center justify-center gap-2 rounded bg-themePrimary400 px-6 py-3 text-sm font-medium text-white transition-all duration-300 hover:bg-opacity-80 md:px-8 md:py-3.5 md:text-base"
                >
                    {customButtonText || t("ctaButton")}
                    <ArrowIcon />
                </Link>
            </div>
        </div>
    );
}